<template>
	<load
		v-if="loading"
		mode="table"
		class="m-0"
		color="#f0f8ff"
		message="Carregando Contatos"
		style="height: 100% !important"
	/>
	<div
		class="col-12 p-1 m-0"
		style="
			height: inherit;
			width: initial;
			box-sizing: content-box;
			overflow: hidden;
		"
		v-else
	>
		<div class="row d-flex justify-content-between align-items-center py-0 px-2">
			<div class="d-flex justify-content-start">
				<h3
					v-if="showContacts"
					class="mb-0 p-0 bg-default btn btn-sm"
					title="Escolher outra Unidade"
					@click="(showContacts = false), (selectedContact = null), (namecontact = '')"
				>
					<i class="mdi mdi-24px mdi-chevron-left"></i>
				</h3>
				<h3 v-if="showContacts" class="box-title mb-0">
					<i class="fa fa-comments"></i>
					<span id="nameContact">
						{{ namecontact ? namecontact : "Que tal conversar com alguém?" }}
					</span>
				</h3>
				<h3
					v-if="showContacts == false && loadingUnidades == false"
					class="box-title mb-0"
				>
					<i class="pl-3 mdi mdi-bank-outline"></i>
					Selecione uma Unidade
				</h3>
			</div>
			<div class="box-tools pull-right mb-0 mx-0" v-if="mode != 'page'">
				<button
					class="btn btn-box-tool btn-chat-fechar m-0 px-2 text-danger"
					v-on:click="
						$emit('minimizar');
						$emit('clear');
					"
				>
					<i class="mdi mdi-close"></i>
				</button>
			</div>
		</div>
		<div
			class="row d-flex align-items-stretch"
			style="height: 80vh; overflow: hidden"
		>
			<!-- mode == 'page'
					? 'height: calc(100vh - 190px);'
					: 'height: calc(100vh - 180px);overflow: hidden;'
			"
		> -->
			<div
				:class="[showContacts ? 'col-md-5' : 'col-md-12']"
				:style="showContacts ? ' overflow: hidden; height:100%; min-height:100%' : ''"
			>
				<div v-if="showContacts">
					<ul
						role="tablist"
						class="nav nav-tabs mb-2"
						v-if="$store.state.settings.ambiente == 'local'"
					>
						<li role="presentation" class="nav-item">
							<a
								@click="tab = 'contatos'"
								class="py-2 nav-link"
								:class="tab == 'contatos' ? 'active' : ''"
							>
								<i class="mdi mdi-account"></i>
								Contatos
							</a>
						</li>
						<li role="presentation" class="nav-item">
							<a
								@click="tab = 'grupos'"
								class="py-2 nav-link"
								:class="tab == 'grupos' ? 'active' : ''"
							>
								<i class="mdi mdi-account-group"></i>
								Grupos
							</a>
						</li>
					</ul>
					<ContactsList
						:contacts="contacts"
						:load="loadingContacts"
						@selected="startConversationWith"
						v-if="tab == 'contatos'"
					/>
					<GroupList
						v-else
						:contacts="contacts"
						:groups="groups"
						:load="loadingContacts"
						@selected="startConversationWithGroup"
						@reload="getGroups"
					/>
				</div>
				<div v-else>
					<UnidadesList
						:unidades="unidades"
						:load="loadingUnidades"
						@selected="getContacts"
					/>
				</div>
			</div>
			<!-- <div class="col-md-7 rounded" style="background: aliceblue"> -->
			<Conversation
				class="col-md-7 rounded"
				style="background: aliceblue; overflow: hidden"
				v-if="selectedContact && showContacts == true"
				:load="loadingConversation"
				:contact="selectedContact"
				:messages="messages"
				:writemessage="writemessage"
				:type="tab"
				@new="onMessage"
				@writing="writingMessage(true)"
				@stop-writing="writingMessage(false)"
			/>
			<!-- </div> -->
			<div
				v-if="selectedContact == null && showContacts"
				class="col-md-7"
				style="background: aliceblue"
			>
				<!-- <h2 class="text-muted">Que tal conversar com alguém?</h2> -->
				<h3 class="text-muted mt-5 text-center" style="margin-top: 40% !important">
					Selecione uma pessoa ao lado e comece o bate-papo!
				</h3>
			</div>
		</div>
	</div>
</template>

<script>
import Conversation from "./Conversation";
import ContactsList from "./ContactsList";
import GroupList from "./GroupList";
import UnidadesList from "./UnidadesList";
import UnreadComponent from "./UnreadComponent";
import { FlowerSpinner } from "epic-spinners";
import socket from "@/dashboard/socket";

export default {
	components: {
		Conversation,
		ContactsList,
		GroupList,
		UnidadesList,
		UnreadComponent,
		FlowerSpinner,
	},
	props: ["minimizar", "mode"],
	data() {
		return {
			loading: false,
			hasNewMessages: false,
			selectedContact: null,
			messages: [],
			contacts: [],
			unidades: [],
			groups: [],
			tab: "contatos",
			newmessage: "",
			namecontact: "",
			loadingConversation: false,
			loadingContacts: true,
			loadingUnidades: true,
			urlsound: `${window.location.protocol}//${window.location.host}sound/chat.mp3`,
			urlApp: `${window.location.protocol}//${window.location.host}`,
			showContacts: false,
			writemessage: false,
		};
	},

	created() {
		socket.on("writing", (content) => {
			if (this.selectedContact && content.id == this.selectedContact.id) {
				this.writemessage = true;
			} else {
				this.writemessage = false;
			}
		});
		socket.on("stop writing", (content) => {
			if (this.selectedContact && content.id == this.selectedContact.id) {
				this.writemessage = false;
			}
		});

		socket.on("set private message", (content) => {
			if (content.from != "Gestao.Suporte" && content.from != "Gestao.Demanda") {
				this.hasNewMessages = true;
				this.$emit("unread", this.hasNewMessages);
				if (this.minimizar == true) {
					this.beep();
				}

				if (this.selectedContact == null || this.selectedContact.id != content.from) {
					this.beep();
				}

				if (this.selectedContact != null && this.selectedContact.id == content.from) {
					this.messages.push(content);
				} else {
					this.unidades.filter((unidade) => {
						// //console.log(unidade.id == parseInt(content.unidade_id));
						// //console.log(unidade);
						// //console.log(content.unidade_id);
						if (unidade.id == parseInt(content.unidade_id)) {
							unidade.unread += 1;
							return true;
						}
					});
				}
				for (let i = 0; i < this.contacts.length; i++) {
					const user = this.contacts[i];
					const fromSelf = socket.userID === content.from;
					// if (user.userID === (fromSelf ? content.to : content.from)) {
					if (
						(this.selectedContact == null || user.id !== this.selectedContact.id) &&
						user.id == content.from
					) {
						this.contacts[i].unread++;
						this.contacts[i].hasNewMessages = true;
					}
					//     break;
					// }
				}
			}
		});
		socket.on("save user logado", (sessionID) => {
			socket.auth = { sessionID };
		});
		socket.on("user connected", (user) => {
			this.setUserConnected(user);
			// socket.emit(
			//     "send user connected",
			//     this.$store.state.user,
			//     user.userID
			// );
		});
		socket.on("users", (users) => {
			// //console.log(users);

			users.forEach((user) => {
				this.setUserConnected(user);
			});

			// socket.emit(
			//     "send user connected",
			//     this.$store.state.user,
			//     user.userID
			// );
		});
		socket.on("in room", (user) => {
			if (user && user.path == this.urlApp) {
				this.$store.state.users.push(user);
			}
		});
		socket.on("user disconnected", (user) => {
			// //console.log(user);
			if (user && user.path == this.urlApp) {
				var index = this.$store.state.users.findIndex(
					(i) => i.id == user || i.userID == user
				);
				// //console.log(index);
				this.$store.state.users.splice(index, 1);
			}
		});

		var user_save = localStorage.getItem("user-chat-selected");
		var group_save = localStorage.getItem("chat-selected-group");
		var unidade_id_save = localStorage.getItem("unidade-chat-selected");

		var user_save_selected = JSON.parse(user_save);

		if (unidade_id_save) {
			this.getContacts(unidade_id_save);
			this.getGroups(unidade_id_save);
		}
		
		if (user_save_selected && unidade_id_save != user_save_selected.unidade_id) {
			localStorage.removeItem("user-chat-selected");
			localStorage.removeItem("chat-selected-group");
		}

		if (group_save) {
			this.tab = "grupos";
			this.selectedContact = JSON.parse(group_save);
			this.startConversationWithGroup(this.selectedContact);
		} else {
			if (user_save) {
				this.tab = "contatos";
				this.selectedContact = JSON.parse(user_save);
				this.updateUnreadMessageCount(this.selectedContact);
				this.startConversationWith(this.selectedContact);
			}
		}
		this.getUnidades();
	},
	methods: {
		updateUnreadMessageCount(selectedContact) {
			if (selectedContact) {
				var index = this.contacts.findIndex((i) => {
					return i.id == selectedContact.id;
				});
				
				if (index > 0) {
					var count = this.contacts[index].unread;
					this.$store.commit("UPDATE_MESSAGE_NUMBER", count);
					this.contacts[index].unread = 0;

					var indexUnidade = this.unidades.findIndex((i) => {
						return i.id == selectedContact.unidade_id;
					});
					if (indexUnidade > 0) {
						this.unidades[indexUnidade].unread = this.unidades[indexUnidade].unread - count;
					}

					localStorage.removeItem("user-chat-selected");
					localStorage.removeItem("chat-selected-group");

					this.$emit("unread", false);
					//console.log("read");
				}
				axios.get(`api/dashboard/chat/markread/${selectedContact.id}`).finally(() => {
					axios
						.get("api/dashboard/chat/contacts/" + selectedContact.unidade_id)
						.then((response) => {
							this.contacts = response.data;
						});
				});
			}
		},
		setUserConnected(user) {
			// let path = this.urlApp;
			// let path = this.$store.state.settings.path;
			var userID = user.length > 1 ? user[0].userID : user.userID;
			// //console.log("ID USER " + userID);
			var verify = this.$store.state.users.filter((item) => {
				return item.userID == userID;
			});
			if (verify && verify.length <= 0) {
				if (user && user.path == this.urlApp) {
					this.$store.state.users.push(user);
				}
			}
			// else {
			//     this.$store.state.users.push(user);
			// }
			// socket.emit("set user logado", this.$store.state.user, this.urlApp);
		},
		writingMessage(status) {
			// let path = this.urlApp;
			let user = this.$store.state.user;
			let destino = this.selectedContact;
			socket.emit("writing", destino, user, this.urlApp, status);
		},
		onMessage(data) {
			let message = data.text;
			// let path = this.urlApp;
			// //console.log(socket);
			// //console.log(path);
			socket.emit("private message", data, this.urlApp);
			this.messages.push(data);
		},
		startConversationWith(contact) {
			this.loadingConversation = true;

			axios.get(`api/dashboard/chat/conversation/${contact.id}`).then((response) => {
				this.messages = response.data;
				this.selectedContact = contact;
				this.updateUnreadMessageCount(this.selectedContact);
				this.namecontact = this.selectedContact.name;
				this.loadingConversation = false;
				localStorage.removeItem("chat-selected-group");
				this.getUnidades();
			});
		},
		startConversationWithGroup(group) {
			this.loadingConversation = true;
			axios
				.get(`api/dashboard/chat/conversation/group/${group.id}`)
				.then((response) => {
					this.messages = response.data;
					this.selectedContact = group;
					this.namecontact = this.selectedContact.name;
					this.loadingConversation = false;
					localStorage.setItem("chat-selected-group", JSON.stringify(group));
					this.getUnidades();
				});
		},
		updateUnreadCount(contact, reset) {
			this.contacts = this.contacts.map((single) => {
				if (single.id !== contact.id) {
					return single;
				}

				if (single.unread > 0) {
					this.beep();
					this.$emit("unread", true);
				}

				return single;
			});
		},
		beep() {
			var audio = document.getElementById("audio");
			if (audio) {
				let startPlayPromise = audio.play();

				if (startPlayPromise !== undefined) {
					startPlayPromise
						.then(() => {
							// Start whatever you need to do only after playback
							// has begun.
						})
						.catch((error) => {
							if (error.name === "NotAllowedError") {
								// showPlayButton(audio);
							} else {
								// Handle a load or playback error
							}
						});
				}
			}
		},
		getUnidades() {
			axios.get("api/dashboard/chat/unidades").then((response) => {
				this.unidades = response.data;
				let counUnread = this.unidades.filter((u) => u.unread > 0);
				counUnread.length > 0 ? (this.hasNewMessages = true) : "";
				this.$emit("unread", this.hasNewMessages);
				this.loadingUnidades = false;

				this.updateUnreadCount(this.unidades, true);
			});
		},
		getContacts(unidadeId) {
			this.loading = true;
			axios
				.get("api/dashboard/chat/contacts/" + unidadeId)
				.then((response) => {
					this.contacts = response.data;
					this.showContacts = true;
					this.loadingContacts = false;
					this.loading = false;
				})
				.finally(() => {
					localStorage.setItem("unidade-chat-selected", unidadeId);
					this.updateUnreadCount(this.contacts, true);
					this.loadingContacts = false;
					this.loading = false;
				});
		},
		getGroups(unidadeId = null) {
			let id = unidadeId ? unidadeId : localStorage.getItem("unidade-chat-selected");
			this.loading = true;
			axios
				.get("api/dashboard/chat/groups/" + id)
				.then((response) => {
					this.groups = response.data;
					this.showContacts = true;
					this.loadingContacts = false;
					this.loading = false;
				})
				.finally(() => {
					this.loadingContacts = false;
					this.loading = false;
				});
		},
	},
};
</script>

<style lang="css" scoped>
.nav-link {
	cursor: pointer;
}
.list-group-item {
	position: relative;
	display: block;
	padding: 0.75rem 1.25rem;
	background-color: #fff;
	border: 0 !important;
	border-bottom: 1px solid #f4f4f4 !important;
	cursor: pointer;
	font-weight: bold;
	font-size: 14px;
	text-transform: uppercase;
}
.list-group-item:hover {
	background: #f4f4f4;
}

::-webkit-scrollbar-track {
	background-color: #f4f4f4;
}
::-webkit-scrollbar {
	width: 5px;
	background: #f4f4f4;
}
::-webkit-scrollbar-thumb {
	background: #979797;
	border-radius: 25em;
}

.morris-hover {
	position: absolute;
	z-index: 99 !important;
}
.new-btn-chat {
	display: flex;
	width: 45px;
	height: 45px;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	border: 0;
	background: #1f89e5;
	color: #fff;
	border-radius: 50%;
	transition: all 0.2s;
	-webkit-transform: scale(1);
	-moz-transform: scale(1);
	-o-transform: scale(1);
	transform: scale(1);
	border: 2px solid #fff;
}

.new-btn-chat:hover {
	background: #44a8ff;
	box-shadow: 0 20px 30px rgba(0, 0, 0, 0.3);
	-webkit-transform: scale(1.4);
	-moz-transform: scale(1.4);
	-o-transform: scale(1.4);
	transform: scale(1.4);
}

.btn-animated {
	animation: moveInBottom 5s ease-out;
	animation-fill-mode: backwards;
}
@keyframes moveInBottom {
	0% {
		opacity: 0;
		transform: scale(1.4);
	}

	100% {
		opacity: 1;
		transform: scale(0px);
	}
}

/* .btn-chat {
  font-size: 18px;
  color: #fff;
  background: #1f89e5;
  padding: 7.5px 10px 7.5px 10px;
  border-radius: 50%;
  box-shadow: 0 1px 4px 0px rgb(0 0 0 / 39%);
  cursor: pointer;
  z-index: 9999;
  min-height: 40px;
  max-height: 40px;
  height: 40px;
  overflow: hidden;
} */
/* .btn-chat:hover {
  background: #0d5a9e;
} */
.chat-app {
	display: flex;
}
.box-chat {
	position: fixed;
	z-index: 1001;
	bottom: 30px;
	right: 30px !important;
	display: block;
	width: 90%;
	height: 90vh;
	overflow: hidden;
	border-radius: 2px;
	background: white;
	box-sizing: content-box;
	box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 15%) !important;
	max-width: 800px;
	padding: 1rem;
}

@media (min-width: 767px) AND (max-width: 1200px) {
	/* .box-chat {
		position: fixed;
		z-index: 1001;
		bottom: 40px;
		right: 40px !important;
		display: block;
		width: 70% !important;
		height: 70vh;
		overflow: initial !important;
		border-radius: 2px;
		background: white;
		box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 15%) !important;
		max-width: 800px;
		overflow: auto;
	} */
}
@media (min-width: 567px) AND (max-width: 767px) {
	/* .box-chat {
		position: fixed;
		z-index: 9999;
		bottom: 60px;
		display: none;
		width: 90%;
	} */
	.direct-chat-info {
		display: block;
		margin-bottom: 2px;
		font-size: 14px;
		width: 400px;
	}
}
@media (max-width: 567px) {
	/* .box-chat {
		position: fixed;
		z-index: 9999;
		bottom: 60px;
		display: none;
		width: 99%;
	} */
	.direct-chat-info {
		display: block;
		margin-bottom: 2px;
		font-size: 14px;
		width: 300px;
	}
}
</style>
